import { render, staticRenderFns } from "./CustomDataTable.vue?vue&type=template&id=86fe6404&scoped=true"
import script from "./CustomDataTable.vue?vue&type=script&lang=js"
export * from "./CustomDataTable.vue?vue&type=script&lang=js"
import style0 from "./CustomDataTable.vue?vue&type=style&index=0&id=86fe6404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fe6404",
  null
  
)

export default component.exports